import React from 'react';

import { ListItem, LocationFilterType } from '../types';

import Item from './Item';

interface SimpleListProps {
    list: ListItem[];
    type: LocationFilterType;
    filter?: string;
    onSelection: (id: number) => void;
    currentSelection: Set<number>;
}

const SimpleList = ({
    list,
    type,
    onSelection,
    currentSelection,
}: SimpleListProps) => (
    <>
        {list.map((item) => (
            <Item
                item={item}
                key={item.id}
                type={type}
                onSelection={onSelection}
                isSelected={currentSelection.has(item.id)}
            />
        ))}
    </>
);

export default SimpleList;
